import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/images/mobAppQr/anyclass_qr.png'


const _hoisted_1 = {
  key: 0,
  class: "mobAppQRModal"
}
const _hoisted_2 = { class: "mobAppQRModal__content" }
const _hoisted_3 = { class: "mobAppQRModal__title" }
const _hoisted_4 = { class: "mobAppQRModal__description" }
const _hoisted_5 = { class: "mobAppQRModal__instruction" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mq_responsive = _resolveComponent("mq-responsive")!

  return (_openBlock(), _createBlock(_component_mq_responsive, { target: "desktop" }, {
    default: _withCtx(() => [
      (_ctx.isOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: "mobAppQRModal__close",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
              }, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("svg", {
                  width: "34",
                  height: "34",
                  viewBox: "0 0 34 34",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "M25.0967 25.0953L8.90625 8.90479M25.0967 8.90479L8.90625 25.0953",
                    stroke: "#5D5667",
                    "stroke-width": "2.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ], -1)
              ]))]),
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('mobAppQRModal.title', { projectName: _ctx.projectName })), 1),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('mobAppQRModal.description')), 1),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mobAppQRModal__qr" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "logo"
                })
              ], -1)),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('mobAppQRModal.instruction')), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}